var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input-number",
    _vm._b(
      {
        on: { change: _vm.handleChange },
        model: {
          value: _vm.initNumberValue,
          callback: function ($$v) {
            _vm.initNumberValue = $$v
          },
          expression: "initNumberValue",
        },
      },
      "el-input-number",
      Object.assign({}, _vm.item, {
        precision: _vm.item.precision ? Number(_vm.item.precision) : undefined,
      }),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }